import * as React from 'react';
import shortid from 'shortid';
import {
  getSearchParams,
  getTranslatedAdult,
  getTranslatedChild,
  getTranslatedPeopleCount,
  getTranslatedChildAges,
  getTranslatedChildAgeLte12,
  getTranslatedMale,
  getTranslatedFemale,
} from '../helper/accommodation_helper';

const MALES_MIN = 0;
const FEMALES_MIN = 0;

class GenderInputUI extends React.Component<any, any> {
  constructor(props) {
    super(props)
    this.state = {
      adults: 1,
      males: 0,
      females: 0,
    }
  }
  componentWillMount() {
    const searchParams = getSearchParams();

    if (searchParams.rooms) {
      const room = searchParams.rooms[0]; // 複数部屋検索対応までは[0]

      if (room.adults != null) {
        this.setState({
          adults: Number(room.adults),
        });
      }
      if (room.males != null) {
        this.setState({
          males: Number(room.males),
        });
      }
      if (room.females != null) {
        this.setState({
          females: Number(room.females),
        });
      }
    }
  }

  minusMales() {
    const { males } = this.state;
    if (males <= MALES_MIN) return;
    const newMales = this.minus(males, MALES_MIN);
    this.setState({
      males: newMales,
    });
  }

  plusMales() {
    const { males, adults } = this.state;
    if (males >= adults) return;
    const newMales = this.plus(males, adults);
    this.setState({
      males: newMales,
    });
  }

  minusFemales() {
    const { females } = this.state;
    if (females <= FEMALES_MIN) return;
    const newFemales = this.minus(females, FEMALES_MIN);
    this.setState({
      females: newFemales,
    });
  }

  plusFemales() {
    const { females, adults } = this.state;
    if (females >= adults) return;
    const newFemales = this.plus(females, adults);
    this.setState({
      females: newFemales,
    });
  }

  plus(num: number, max: number) {
    let newNumber;
    if (num < max) {
      newNumber = Number(num) + 1;
    } else {
      newNumber = max;
    }
    return newNumber;
  }

  minus(num: number, min: number) {
    let newNumber;
    if (num > min) {
      newNumber = Number(num) - 1;
    } else {
      newNumber = min;
    }
    return newNumber;
  }

  render() {
    return (
      <React.Fragment>
        <div className="sy_step_layout">
          <div className="linewrapper">
            <div className="sy_booking_line_label">{getTranslatedMale()}</div>
            <div className="sy_info_description" />
          </div>
          <div className="sy_button_container">
            <div
              className={`sy_count_button sy_button_down ${this.state.males === MALES_MIN ? "sy_count_button_disabled" : ""}`}
              onClick={this.minusMales.bind(this)}
            />
            <input className="sy_count_number" name="rooms[0][males]" readOnly type="text" value={this.state.males} onKeyPress={(e)=>{e.charCode === 13 && e.preventDefault();}} />
            <div
              className={`sy_count_button sy_button_up ${this.state.males === this.state.adults ? "sy_count_button_disabled" : ""}`}
              onClick={this.plusMales.bind(this)}
            />
          </div>
        </div>
        <div className="sy_step_layout last">
          <div className="linewrapper">
            <div className="sy_booking_line_label">{getTranslatedFemale()}</div>
          </div>
          <div className="sy_button_container">
            <div
              className={`sy_count_button sy_button_down ${this.state.females === FEMALES_MIN ? "sy_count_button_disabled" : ""}`}
              onClick={this.minusFemales.bind(this)}
            />
            <input className="sy_count_number" name="rooms[0][females]" readOnly type="text" value={this.state.females} onKeyPress={(e)=>{e.charCode === 13 && e.preventDefault();}} />
            <div
              className={`sy_count_button sy_button_up ${this.state.females === this.state.adults ? "sy_count_button_disabled" : ""}`}
              onClick={this.plusFemales.bind(this)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default GenderInputUI;
